const phrases = [
    'سلام به آینده و آیندگان',
    'روز خوبی داشته باشی',
    'این یک پیام تصادفی است',
    'به دنیای جدید خوش آمدید',
    'آیا آماده هستید؟',
]
export const getRandomPhrase = () => {
    const randomIndex = Math.floor(Math.random() * phrases.length)
    return phrases[randomIndex]
}

export const MAX_VIDEO_SIZE = 5 * 1024 * 1024 // 5 MB
